import React from 'react'


function isValidCategory(category){
  if (!category.entries || category.entries.length == 0) return false
  if (category.entries.length == 1 && !category.entries[0].title || category.entries[0].title.length == 0) return false
  return true
}


export default class CV extends React.Component {
  render(){
    const { data, width=640, showDate=true } = this.props
    return (
      <div style={{width: '100%', overflow: 'visible', display: 'block', margin: '0 auto'}}>
        <div style={{maxWidth: width,margin: 'auto',height:'auto',display: 'block'}}>
          <table border="0" className="cv--table">
              <tbody>
          {data.map((category, idx) => {
            // Hide empty categories
            if (!isValidCategory(category)) return null 
            return [
              (<tr style={{lineHeight: '1.3em'}}>
                {showDate && <td style={{marginRight: 16}}></td>}
                <td><h3 style={{color: '#034f84', fontSize: '1.5em'}}>{category.title}</h3></td>
              </tr>),
              category.entries.map((entry, idx) => (
                <tr key={idx} style={{lineHeight: '1.4em'}}>
                  {showDate && <td style={{color: '#034f84', width: 76, paddingRight: 20, verticalAlign: 'top', textAlign: 'right'}} className="table__item--secondary" >{entry.date}</td>}
                  <td>
                    <span className="table__item--primary">{entry.title}</span>
                    {entry.director && <span className="table__item--secondary" style={{paddingLeft: 16}}>{entry.director}</span>}
                    {entry.comment && <div className="table__item--secondary" style={{fontSize: '0.9em'}}>{entry.comment}</div>}
                  </td>
                </tr>
              ))
            ]
          }
        )}
              </tbody>
          </table>
        </div>
      </div>
    )
  }
}


/** WEBPACK FOOTER **
 ** ./src/profile/CV.js
 **/